import React from 'react';
import '../components/Polymathy.css';

const FinancialServicesPage = () => {
  const financialServices = [
    {
      area: 'Strategic Financial Advisory',
      description: 'We partner with you to develop and execute comprehensive financial strategies that maximize profitability and drive sustainable growth. Provide CFO-level insights to Boards and Executives on profitability, capital allocation, and financial strategy.'
    },
    {
      area: 'Executive Insight & Performance Dashboarding',
      description: 'We transform raw data into clear, actionable executive dashboards and reports, ensuring leadership has the timely insights needed to monitor KPIs and drive strategic decisions.'
    },
    {
      area: 'Financial & Operational Data Intelligence',
      description: 'We design and deliver integrated management reports that connect financial outcomes with underlying operational drivers, providing a comprehensive, single source of truth for all business units.'
    },
    {
      area: 'Finance Function Transformation',
      description: 'We partner with you to re-engineer your entire finance operating model—including organizational structure, service delivery, and shared services—to reduce costs, enhance controls, and increase strategic value.'
    },
    {
      area: 'Management Reporting',
      description: 'Preparation of internal financial reports for decision-making—P&L, cash flow, budget vs actuals.'
    },
    {
      area: 'Integrated Budgeting and Predictive Modeling',
      description: 'We provide expert guidance in developing dynamic, zero-based, or activity-based budgets coupled with scenario-based financial models to accurately project future cash flow and performance.'
    },
    {
      area: 'Financial Reporting & Compliance',
      description: 'We ensure your financial statements are fully compliant with regulatory standards (e.g., GAAP, IFRS) and provide the accurate, timely reporting necessary to satisfy stakeholders, mitigate compliance risk, and maintain sound financial governance.'
    },
    {
      area: 'Taxation Advisory & Compliance',
      description: 'We handle the complete lifecycle of tax compliance, ensuring accurate, timely filing across all relevant jurisdictions while providing the necessary assurance to mitigate risk of audits and penalties.'
    },
    {
      area: 'Strategic Cost Management & Profit Optimization',
      description: 'We implement advanced cost accounting methodologies to provide granular visibility into product, service, and customer profitability, allowing you to cut waste and strategically optimize pricing and operations. Accurately identify true profit drivers and eliminate low-value activities.'
    },
    {
      area: 'Working Capital Optimization & Cash Flow Management',
      description: 'We help you accelerate cash conversion cycles, freeing up capital for growth. Our service provides robust cash flow forecasting and modeling to ensure optimal liquidity and financial stability.'
    },
    {
      area: 'Streamlined Transaction Processing & Reconciliation',
      description: 'We provide meticulous, end-to-end management of your daily financial transactions, ensuring data accuracy, regulatory compliance, and a clean foundation for all your accounting and reporting needs.'
    }
  ];

  return (
    <section className="polymathy-section">
      <div className="container">
        <div className="polymathy-header">
          <h2 className="section-title center">FINANCIAL SERVICES</h2>
          <div className="title-underline center"></div>
          <p className="polymathy-subtitle">
            Comprehensive financial strategy and operational excellence
          </p>
        </div>

        <div className="services-section">
          <div className="service-category-section">
            <div className="services-table">
              <div className="services-header">
                <span>Service Area</span>
                <span>Description</span>
              </div>
              {financialServices.map((service) => (
                <div key={service.area} className="service-row">
                  <div className="service-area">{service.area}</div>
                  <div className="service-description">
                    <p>{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinancialServicesPage;

